import { Box, Button, CardMedia, Dialog, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
// eslint-disable-next-line
import { Formik, setNestedObjectValues } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  sendOtp,
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  sendConsentEmail,
} from '../../redux-store/actions/onBoarding';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nonDigitRegex,
  nonIndividualPanRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  futureAge,
  getCountryCodes,
  isMinor,
  isOnboardingTypeMinor,
  maxAge,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  AML_ALL_DISPLAY_MODE,
  APPLICATION_TYPE,
  // eslint-disable-next-line
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_OPTIONS,
  onboardingTypeMasters,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { AmlPopup, AmlPopupValues, MobileNumberField } from '../commonComponents';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
interface Values {
  pan: string;
  dob: string;
  onboardingType: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
}
interface EValues {
  pan: string;
  emailId: string;
  dob: string;
  hasPOA: boolean;
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const { redirectTo = '', firstHolderName = '', application } = location.state || {};
  const { id, applicants = [], hasPOA } = application || {};
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        const isPANWithP = fieldValue[3] === 'P';
        const isMinorOnboarding = isOnboardingTypeMinor(parent.onboardingType);
        if (isPANWithP) {
          if (!individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'Invalid PAN',
              path,
            });
          }
          if (applicantPanNumbers.includes(fieldValue)) {
            return createError({
              message:
                'There is already the same PAN for an applicant associated with this application',
              path,
            });
          }
        } else if (
          !nonIndividualPanRegex.test(fieldValue) ||
          (nonIndividualPanRegex.test(fieldValue) && isMinorOnboarding)
        ) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),
    dob: yup
      .string()
      .nullable()
      .test('dob', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (IS_DOB_APPLICABLE_FOR_AMC) {
          if (!fieldValue) {
            return createError({
              message: 'Date of birth is required',
              path,
            });
          } else if (
            futureAge(fieldValue) ||
            fieldValue.toString().toLowerCase() === 'Invalid date'
          ) {
            return createError({
              message: 'Invalid Date',
              path,
            });
          } else if (isMinor(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be greater than 18',
              path,
            });
          } else if (maxAge(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be less than 125',
              path,
            });
          }
        }

        return true;
      }),
  });
  const initialValues1: Values = { pan: '', dob: '', onboardingType: 'normal' };
  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody,
    pan: string,
    dob: string
  ) => {
    if (hasPOA) {
      const { panVerificationToken } = response || {};
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await dispatch(addJointHolder({ applicantVerificationToken }, id));
      history.push(redirectTo, { id });
      return;
    }
    //need to fetch POA status here due to multiple calls happening when network goes offline in enter mobile/emailid  screen
    const res = (await dispatch(IsApplicableForPOA())) as unknown as IsApplicableForPOAResponseBody;
    const { powerOfAttorney } = res;

    if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) {
      return history.push('enter-email-id', {
        pan: pan.toUpperCase(),
        dob: dob,
        ...(response || {}),
        powerOfAttorney,
      });
    }
    history.push('enter-mobile-number', {
      pan: pan.toUpperCase(),
      dob: dob,
      ...(response || {}),
      redirectTo,
      firstHolderName,
      application,
      powerOfAttorney,
    });
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const { pan, dob, onboardingType } = values;
      const response = (await dispatch(
        verifyPan({ pan, dob, onboardingType })
      )) as unknown as VerifyPanResponseBody;
      if (!response.amlCheck) {
        const { system_match = [], referral_match = [] } = response.amlData || {};
        const matches = AML_ALL_DISPLAY_MODE
          ? [...system_match, ...referral_match]
          : [system_match[0] || referral_match[0]].filter(Boolean);
        setAmlFailedresponse(
          matches.length
            ? {
                ...matches[0],
                FURTHER_INFORMATION: matches
                  .map((m) => m.FURTHER_INFORMATION)
                  .filter(Boolean)
                  .join('\n\n'),
                EXTERNAL_SOURCES: matches
                  .map((m) => m.EXTERNAL_SOURCES)
                  .filter(Boolean)
                  .join('\n'),
              }
            : undefined
        );
        return setAmlPopup({
          panVerificationToken: response.panVerificationToken,
          pan: pan,
          dob: dob,
        });
      }
      routingAfterPanVerification(response, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };

  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const { panVerificationToken = '', pan = '', dob = '' } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification(response, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, resetForm, values }) => (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <UseRadioGroup
                disabled={id ? true : false}
                formLabel="Investor Type*"
                name="onboardingType"
                items={Object.keys(onboardingTypeMasters).map((type) => ({
                  value: type,
                  label: onboardingTypeMasters[type],
                }))}
              />
              {isOnboardingTypeMinor(values.onboardingType) && (
                <Box
                  sx={{
                    '& .MuiSvgIcon-root': { display: 'none' },
                    '& .MuiTypography-root': { ml: 0 },
                  }}>
                  <Notes
                    displayContent={
                      'You have selected Minor Investor Onboarding. Please provide Guardian PAN and Date of Birth'
                    }
                  />
                </Box>
              )}
              <MFTextField
                label={isOnboardingTypeMinor(values.onboardingType) ? 'Guardian PAN' : 'PAN'}
                name="pan"
                placeholder="Enter PAN"
                required
                autoComplete="off"
                inputProps={{ style: { textTransform: 'uppercase' } }}
              />
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  label={
                    isOnboardingTypeMinor(values.onboardingType)
                      ? 'Guardian Date of Birth'
                      : 'Date of Birth/Incorporation'
                  }
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'DD/MM/YYYY'}
                  name="dob"
                />
              )}

              <MFSubmitButton label="Verify PAN" loadingEnable={amlAcknowledgementLoading} />
              <Notes
                displayContent={
                  'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically. Pan will be checked against World-Check database for AML compliance.'
                }
              />
            </Box>
            <Dialog open={open} onClose={() => setOpen(false)}>
              <Box
                sx={{
                  p: { xs: 2, sm: 8 },
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <Box sx={{ mb: 8 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      width: '70%',
                      mb: 5,
                    }}>
                    Unable to verify the details please contact admin
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => {
                      resetForm();
                      setOpen(false);
                    }}
                    sx={{ color: 'common.white' }}>
                    Enter another PAN
                  </Button>
                </Box>
              </Box>
            </Dialog>
            <AmlPopup
              handleClose={handleClose}
              amlPopupOpen={amlPopup !== null}
              onSubmit={onSubmit}
              FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
              EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
              displayDocInfo={true}
            />
          </>
        )}
      </Formik>
    </>
  );
}
export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    amlCheck: boolean;
    powerOfAttorney: boolean;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    amlCheck = false,
    powerOfAttorney = false,
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  // eslint-disable-next-line
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });
  const initialValues1: MValues = {
    pan: pan,
    mobile: '',
    emailId: '',
    bypassOtp: true,
    skipOtpModal: false,
    hasPOA: false,
    dob: dob,
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    onboardingOtpEmailConsent: 'otp',
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/application/distributor-details', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    const {
      pan,
      mobile = '',
      bypassOtp = true,
      hasPOA,
      emailId,
      // eslint-disable-next-line
      countryCode = '+91',
      countryNameAndCode = 'India: +91',
      onboardingOtpEmailConsent = 'otp',
    } = values;
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await handleCreateApplication(applicantVerificationToken);
      return;
    }
    if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
      (await dispatch(
        sendConsentEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          applicationId: id || '',
        })
      )) as unknown as SendConsentEmailResponseBody;
      enqueueSnackbar('Email sent successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      return history.push(
        [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
          ? `/applications-list`
          : '/applications'
      );
    }

    const response = (await dispatch(
      sendOtp({
        phoneNumber: mobile.trim(),
        emailId,
        panVerificationToken,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        bypassOtp,
      })
    )) as unknown as SendOtpResponseBody;

    const { applicantVerificationToken, phoneNumber } = response || {};
    if (bypassOtp) {
      if (id && redirectTo) {
        (await dispatch(
          addJointHolder({ applicantVerificationToken }, id)
        )) as unknown as ApplicationProps;
        history.push(redirectTo, { id });
        return;
      }
      handleCreateApplication(applicantVerificationToken);
      return;
    }
    history.push('enter-otp', {
      pan,
      unmaskedphone: mobile.trim(),
      umaskedemailId: emailId,
      mobile: phoneNumber,
      panVerificationToken,
      redirectTo,
      application,
      email: (response || {}).emailId,
      firstHolderName,
      countryCode: countryNameAndCode?.split(':')[1].trim(),
      countryNameAndCode,
      ...(response || {}),
    });
  };

  useEffect(() => {
    // (async function () {
    //   const res = (await dispatch(
    //     IsApplicableForPOA()
    //   )) as unknown as IsApplicableForPOAResponseBody;
    //   const { powerOfAttorney } = res;
    setDisablePOA(
      application
        ? application.hasPOA
          ? application.hasPOA
          : !application.hasPOA
        : !powerOfAttorney
    );
    // })();
  }, []);
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({
          handleSubmit,
          values,
          // eslint-disable-next-line
          validateForm,
          isSubmitting,
          // eslint-disable-next-line
          setTouched,
          // eslint-disable-next-line
          setErrors,
          setFieldValue,
        }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ position: 'relative' }}>
              <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                <CardMedia
                  component="img"
                  src="/images/tick.svg"
                  sx={{ width: '18px', float: 'right' }}
                />
              </Box>
              <MFTextField
                label="PAN"
                name="pan"
                placeholder="Enter PAN"
                required
                inputProps={{ style: { textTransform: 'uppercase' } }}
                disabled={true}
                applyMarginBottom={false}
              />
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: 'rgba(35, 133, 63, 0.7)', mb: 0.5 }}>
                KYC Verified,{' '}
                <Typography
                  variant="body2"
                  component={'span'}
                  sx={{
                    fontWeight: 600,

                    color: amlCheck ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',

                    mb: 0.5,
                  }}>
                  AML Check {amlCheck ? 'Passed' : 'Failed'}
                </Typography>
                , Pan Aadhaar Linked
              </Typography>
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                  label={'Date of birth'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'Enter Date of birth'}
                  name="dob"
                  disabled={true}
                />
              )}

              <MFCheckbox
                name="hasPOA"
                label="Power of Attorney"
                color="primary"
                sx={{
                  '.MuiTypography-root': {
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    letterSpacing: '0.9625px',
                  },
                }}
                disabled={disablePOA}
              />
            </Box>
            {!values.hasPOA && (
              <>
                <MobileNumberField
                  label={'Mobile Number'}
                  name={`mobile`}
                  placeholder="Enter Mobile number"
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  countryCodeFieldName={'countryNameAndCode'}
                  countryCodeValue={values.countryNameAndCode}
                  regexForFilterValue={nonDigitRegex}
                />
                {ENABLE_EMAIL_OTP && (
                  <MFTextField
                    autoComplete="off"
                    // autoFocus
                    label="Email ID"
                    name="emailId"
                    placeholder="Enter Email ID"
                    required
                  />
                )}
                {/* {ENABLE_Email_Consent && (
                  <UseRadioGroup
                    formLabel=""
                    name={`onboardingOtpEmailConsent`}
                    defaultValue="otp"
                    items={Object.keys(ONBOARDING_OPTIONS).map((option) => ({
                      label: ONBOARDING_OPTIONS[option],
                      value: option,
                    }))}
                  />
                )} */}
                <Notes
                  displayContent={
                    'Provide the mobile phone number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
                  }
                />
              </>
            )}
            {/* <MFSubmitButton
              label={
                values.hasPOA
                  ? 'Continue'
                  : ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                    ONBOARDING_OPTIONS.email_consent
                  ? 'Send Email'
                  : 'Get OTP'
              }
            /> */}
            <MFSubmitButton label={'Continue'} />
            {/* {!values.hasPOA &&
              ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                ONBOARDING_OPTIONS.otp && (
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    color: 'common.white',
                    fontWeight: 500,
                    fontSize: 14,
                    mt: 0.5,
                    lineHeight: 1.5,
                  }}
                  onClick={async () => {
                    const error = await validateForm();
                    if (Object.keys(error).length) {
                      setTouched(setNestedObjectValues(error, true));
                      setErrors(error);
                      return;
                    }
                    setFieldValue('skipOtpModal', true);
                  }}>
                  Proceed
                </Button>
              )} */}
            <Dialog open={values.skipOtpModal} onClose={() => setFieldValue('skipOtpModal', false)}>
              <Box
                sx={{
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <IconButton
                    onClick={() => setFieldValue('skipOtpModal', false)}
                    sx={{ alignSelf: 'flex-end' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                  {/* <Box sx={{ mb: 4 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box> */}
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      mb: 5,
                      width: '90%',
                    }}>
                    Are you sure you want to Skip OTP Verification?
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'space-around',
                      width: '100%',
                    }}>
                    <Button
                      variant="outlined"
                      disabled={isSubmitting}
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ color: 'primary.main', mb: 2 }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => {
                        setFieldValue('bypassOtp', true);
                        handleSubmit();
                      }}>
                      Continue
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Dialog>
          </Box>
        )}
      </Formik>
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    amlCheck: boolean;
    powerOfAttorney: boolean;
  }>;
}): JSX.Element {
  const {
    panVerificationToken,
    pan,
    dob,
    amlCheck = false,
    powerOfAttorney = false,
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'Invalid PAN',
            path,
          });
        }
        return true;
      }),

    emailId: yup.string().when('hasPOA', {
      is: (hasPOA: boolean) => (disablePOA ? true : !hasPOA),
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),
  });
  const initialValues1: EValues = {
    pan: pan,
    emailId: '',
    dob: dob,
    hasPOA: false,
  };

  useEffect(() => {
    setDisablePOA(!powerOfAttorney);
  }, []);

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/non-individual-application', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId, hasPOA } = values;
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await handleCreateApplication(applicantVerificationToken);
      return;
    }
    const response = (await dispatch(
      SendEmail({ panVerificationToken, emailId })
    )) as unknown as VerifyOtpResponseBody;
    const { applicantVerificationToken } = response || {};
    await handleCreateApplication(applicantVerificationToken);
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, values }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Box sx={{ position: 'relative' }}>
              <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                <CardMedia
                  component="img"
                  src="/images/tick.svg"
                  sx={{ width: '18px', float: 'right' }}
                />
              </Box>
              <MFTextField
                label="PAN"
                name="pan"
                placeholder="Enter PAN"
                required
                inputProps={{ style: { textTransform: 'uppercase' } }}
                disabled={true}
              />
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: 'rgba(35, 133, 63, 0.7)', mb: 0.5 }}>
                KYC Verified,{' '}
                <Typography
                  variant="body2"
                  component={'span'}
                  sx={{
                    fontWeight: 600,

                    color: amlCheck ? 'rgba(35, 133, 63, 0.7)' : '#BD2932',

                    mb: 0.5,
                  }}>
                  AML Check {amlCheck ? 'Passed' : 'Failed'}
                </Typography>
              </Typography>
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                  label={'Date of Birth/Incorporation'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'Enter Date of birth'}
                  name="dob"
                  disabled={true}
                />
              )}
            </Box>

            <MFCheckbox
              name="hasPOA"
              label="Power of Attorney"
              color="primary"
              sx={{
                '.MuiTypography-root': {
                  color: 'primary.main',
                  fontWeight: 500,
                  fontSize: 14,
                  letterSpacing: '0.9625px',
                },
              }}
              disabled={disablePOA}
            />
            {!values.hasPOA && (
              <>
                <MFTextField
                  autoComplete="off"
                  autoFocus
                  label="Contact Person Email ID"
                  name="emailId"
                  placeholder="Enter Contact Person Email ID"
                  required
                />

                <Notes
                  displayContent={
                    'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
                  }
                />
              </>
            )}
            <MFSubmitButton label={'Proceed'} />
          </Box>
        )}
      </Formik>
    </>
  );
}
